import { render, staticRenderFns } from "./AddClientModal.vue?vue&type=template&id=8f4f1d20&scoped=true&"
import script from "./AddClientModal.vue?vue&type=script&lang=js&"
export * from "./AddClientModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClientModal.vue?vue&type=style&index=0&id=8f4f1d20&prod&lang=css&"
import style1 from "./AddClientModal.vue?vue&type=style&index=1&id=8f4f1d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4f1d20",
  null
  
)

export default component.exports